export const DEVSTACK_DOMAIN_SUFFIX = '.devstack.asix.pro'

/**
 * Erkennt ob die App in einer Dev-Umgebung läuft.
 * - DevStack: Hostnames mit Suffix `.devstack.asix.pro` (Haupt-Instanz oder Worktree-Subdomain)
 * - Localhost: `localhost` oder `127.0.0.1` (lokaler vite/dev-server)
 *
 * `isDevEnvironment` ist `true` wenn eine der beiden Bedingungen zutrifft.
 * Verwende dieses Composable statt direkter `window.location`-Checks, damit
 * Feature-Gating konsistent bleibt.
 */
export function useDevEnvironment() {
  const isDev = process.env.NODE_ENV === "development"
  const hostname = window.location.hostname
  const isDevStack = hostname.endsWith(DEVSTACK_DOMAIN_SUFFIX)
  const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1'
  return { isDevStack, isLocalhost, isDevEnvironment: isDev || isDevStack || isLocalhost }
}
